var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralInformationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#B4A085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 19.5H29V17.5C29 16.39 28.11 15.5 27 15.5H23C21.89 15.5 21 16.39 21 17.5V19.5H17C15.89 19.5 15.01 20.39 15.01 21.5L15 32.5C15 33.61 15.89 34.5 17 34.5H33C34.11 34.5 35 33.61 35 32.5V21.5C35 20.39 34.11 19.5 33 19.5ZM27 19.5H23V17.5H27V19.5Z",
    fill: "#B4A085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInformationActiveIcon);
export default __webpack_public_path__ + "static/media/general_information_active_icon.fc18daeff9138a89347ccd9732f1ed36.svg";
export { ForwardRef as ReactComponent };